import script from "./cashbackNotice.vue?vue&type=script&lang=ts&setup=true"
export * from "./cashbackNotice.vue?vue&type=script&lang=ts&setup=true"

import "./cashbackNotice.vue?vue&type=style&index=0&id=078c1c1c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-078c1c1c"]])

export default __exports__